import {inject, Injectable, Signal, signal} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RouteHistoryService {
  #router = inject(Router);

  #previousUrl = signal<string | null>(null);
  #currentUrl = signal<string | null>(null);

  constructor() {
    this.#router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
      )
      .subscribe((event: any) => {
        const newPath = this.#stripQueryParams(event.urlAfterRedirects);
        const currentUrl = this.#currentUrl();

        if (currentUrl && this.#stripQueryParams(currentUrl) !== newPath) {
          this.#previousUrl.set(currentUrl);
        }

        this.#currentUrl.set(event.urlAfterRedirects);
      });
  }

  previousUrl(): Signal<string | null> {
    return this.#previousUrl.asReadonly();
  }

  goBack() {
    const previous = this.#previousUrl();
    if (previous) {
      this.#router.navigateByUrl(previous);
    }
  }

  #stripQueryParams(url: string): string {
    return url.split('?')[0];
  }
}
